<script>
import EditLineItem from './../../../LineItem/Modal/Edit.vue'
export default {
  extends: EditLineItem,
  computed: {
    isSubOrder() {
      return true
    },
    lineItemIdentify() {
      return this.config?.data?.identify || null
    },
    getUri() {
      if (!this.config?.data?.editable) {
        return `line-item/get/${this.lineItemIdentify}`
      }
      return null
    }
  },
  created() {
    if (this.config?.data?.editable) {
      this.setUpData({
        status: 'success',
        data: _.cloneDeep(this.config?.data)
      })
    }
  },
  methods: {
    submit() {
      let newAttributes = Object.assign({}, this.data.attributes)
      this.newAttributes.forEach((object) => {
        newAttributes[object.name] = object.value
      })

      let data = Object.assign({}, this.data, {
        design_flag: this.designFlag,
        new_design_name: this.suggestDesignName,
        attributes: newAttributes,
        index: this.config?.data.index,
        editable: true
      })
      this.$emitter.emit('Modal.Order.CreateSubOrder.EditLineItem.Submit', data)
      this.$emit('close')
    }
  }
}
</script>
